import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  container: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
  },
  root: {
    maxWidth: 1000,
  },
  header: {
    marginBottom: theme.spacing(3),
  },
  title: {
    fontWeight: 700,
    fontSize: 32,
    color: '#00234B',
    marginBottom: theme.spacing(0.5),
    fontFamily: '"Source Serif Pro", serif',
    [theme.breakpoints.down('sm')]: {
      fontSize: 26,
    },
  },
  subtitle: {
    fontSize: 14,
    color: '#6A6A6A',
  },
  tableContainer: {
    backgroundColor: '#FFFFFF',
    borderRadius: 8,
    border: '1px solid #E0E0E0',
    boxShadow: 'none',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      overflowX: 'auto',
    },
  },
  table: {
    minWidth: 650,
    [theme.breakpoints.down('sm')]: {
      minWidth: 'auto',
    },
  },
  tableHead: {
    backgroundColor: '#FAFAFA',
  },
  tableHeadCell: {
    fontWeight: 600,
    fontSize: 11,
    color: '#6A6A6A',
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    borderBottom: '1px solid #E0E0E0',
    padding: theme.spacing(1.5, 2),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1, 1.5),
      fontSize: 10,
    },
  },
  tableRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#F9FAFB',
    },
    '&:last-child td': {
      borderBottom: 0,
    },
  },
  tableCell: {
    padding: theme.spacing(2),
    borderBottom: '1px solid #F0F0F0',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1.5),
    },
  },
  courseCell: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
  },
  courseIconContainer: {
    width: 40,
    height: 40,
    borderRadius: 8,
    backgroundColor: '#E8F4FD',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      width: 36,
      height: 36,
    },
  },
  courseIcon: {
    color: '#1976D2',
    fontSize: 20,
  },
  courseInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  courseNameContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
  },
  courseName: {
    fontWeight: 600,
    fontSize: 14,
    color: '#00234B',
    [theme.breakpoints.down('sm')]: {
      fontSize: 13,
    },
  },
  courseLocation: {
    fontSize: 12,
    color: '#6A6A6A',
    [theme.breakpoints.down('sm')]: {
      fontSize: 11,
    },
  },
  dateCell: {
    fontSize: 14,
    color: '#333333',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
    },
  },
  holeCell: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 32,
    height: 32,
    border: '1px solid #E0E0E0',
    borderRadius: 4,
    fontSize: 13,
    fontWeight: 600,
    color: '#333333',
    [theme.breakpoints.down('sm')]: {
      width: 28,
      height: 28,
      fontSize: 12,
    },
  },
  parCell: {
    fontSize: 14,
    color: '#333333',
    fontWeight: 500,
    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
    },
  },
  distanceCell: {
    fontSize: 14,
    color: '#333333',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
    },
  },
  detailsCell: {
    color: '#9E9E9E',
    fontSize: 20,
  },
  chevronIcon: {
    color: '#BDBDBD',
  },
  pagination: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2),
    borderTop: '1px solid #E0E0E0',
    backgroundColor: '#FAFAFA',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1.5),
      flexWrap: 'wrap',
      gap: theme.spacing(1),
    },
  },
  paginationText: {
    fontSize: 13,
    color: '#6A6A6A',
  },
  paginationButtons: {
    display: 'flex',
    gap: theme.spacing(1),
  },
  paginationButton: {
    minWidth: 32,
    width: 32,
    height: 32,
    padding: 0,
    color: '#9E9E9E',
    '&:hover': {
      backgroundColor: '#F0F0F0',
    },
    '&.Mui-disabled': {
      color: '#E0E0E0',
    },
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(8),
  },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(8),
    textAlign: 'center',
  },
  emptyStateIcon: {
    fontSize: 64,
    color: '#E0E0E0',
    marginBottom: theme.spacing(2),
  },
  emptyStateTitle: {
    fontWeight: 600,
    fontSize: 18,
    color: '#333333',
    marginBottom: theme.spacing(1),
  },
  emptyStateText: {
    fontSize: 14,
    color: '#6A6A6A',
  },
}))

export default useStyles
